module.exports = __webpack_public_path__ + "img/grupodesitios.f2396681.png";